export enum SvgActions {
  Reset = 'reset',
  Plus = 'plus',
  Minus = 'minus',
  Render = 'render'
}